var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "participantes-products" }, [
    _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "product-header" }, [
          _vm._v("\n        Nome\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "product-header" }, [
          _vm._v("\n        KPI\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "product-header" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.isComercial
                  ? "Escoamento/Quantidade"
                  : "Escoamento informado"
              ) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _vm.hasTotalAcceleratorSDZ && _vm.isComercial
          ? _c("th", { staticClass: "product-header" }, [
              _vm._v("\n        Total acelerador\n      "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("th", { staticClass: "product-header" }, [
          _vm._v("\n        Total SDZ\n      "),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.products, function (product) {
        return _c("tr", { key: product._id }, [
          _c("td", { staticClass: "product-details" }, [
            _vm._v("\n        " + _vm._s(product.name) + "\n      "),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "product-details" }, [
            _vm._v("\n        " + _vm._s(product.kpi || "-") + "\n      "),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "product-details" }, [
            _vm._v("\n        " + _vm._s(product.sellOut || "-") + "\n      "),
          ]),
          _vm._v(" "),
          _vm.hasTotalAcceleratorSDZ && _vm.isComercial
            ? _c("td", { staticClass: "product-details" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(product.totalAcceleratorSeedz) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("td", { staticClass: "product-details" }, [
            _vm._v("\n        " + _vm._s(product.totalSeedz) + "\n      "),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }